import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Calendar, Phone, MapPin } from "lucide-react";

interface Location {
  name: string;
  address: string;
  postcode: string;
  phone: string;
  phonetext: string;
  appointmentUrl: string;
}

const locations: Location[] = [
  {
    name: "Dordrecht Stadspolders",
    address: "Van Eesterenplein 95",
    postcode: "3315 KT Dordrecht",
    phone: "+31782200020",
    phonetext: "078 - 220 00 20",
    appointmentUrl: "https://www.hypotheekshop.nl/afspraak-maken/dordrechtstadspolders/"
  },
  {
    name: "Zwijndrecht",
    address: "Hof van Holland 132",
    postcode: "3333 CE Zwijndrecht",
    phone: "+31782200024",
    phonetext: "078 - 220 00 24",
    appointmentUrl: "https://www.hypotheekshop.nl/afspraak-maken/zwijndrecht/"
  },
  {
    name: "Papendrecht",
    address: "Veerweg 139",
    postcode: "3356 LJ Papendrecht",
    phone: "+31782200026",
    phonetext: "078 - 220 00 26",
    appointmentUrl: "https://www.hypotheekshop.nl/afspraak-maken/papendrecht/"
  },
  {
    name: "Dordrecht Centrum",
    address: "Johan de Wittstraat 168",
    postcode: "3311 KN Dordrecht",
    phone: "+31786135433",
    phonetext: "078 - 613 54 33",
    appointmentUrl: "https://www.hypotheekshop.nl/afspraak-maken/dordrechtcentrum/"
  },
  {
    name: "Rotterdam Oostplein",
    address: "Oostplein 570",
    postcode: "3061 CZ Rotterdam",
    phone: "+31102136972",
    phonetext: "010 - 213 69 72",
    appointmentUrl: "https://www.hypotheekshop.nl/afspraak-maken/rotterdamoostplein/"
  },
  {
    name: "Gorinchem",
    address: "Havendijk 2",
    postcode: "4201 XB Gorinchem",
    phone: "+31183893010",
    phonetext: "0183 - 893 010",
    appointmentUrl: "https://www.hypotheekshop.nl/afspraak-maken/gorinchem/"
  }
];

interface LocationSelectorProps {
  children: React.ReactNode;
  type: 'call' | 'appointment';
}

export const LocationSelector = ({ children, type }: LocationSelectorProps) => {
  const handleLocationAction = (location: Location) => {
    if (type === 'call') {
      window.location.href = `tel:${location.phone}`;
    } else {
      window.open(location.appointmentUrl, '_blank');
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-center">
            {type === 'call' ? 'Kies een vestiging om te bellen' : 'Kies een vestiging voor uw afspraak'}
          </DialogTitle>
        </DialogHeader>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
          {locations.map((location, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => handleLocationAction(location)}>
              <CardContent className="p-4">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="font-semibold text-foreground text-sm">{location.name}</h3>
                  <img 
                    src="/assets/logo-hypotheekshop.webp" 
                    alt="De Hypotheekshop logo" 
                    className="w-8 h-8 object-contain"
                  />
                </div>
                <div className="space-y-1 text-xs text-muted-foreground mb-4">
                  <div className="flex items-center">
                    <MapPin className="w-3 h-3 mr-1" />
                    <span>{location.address}</span>
                  </div>
                  <div className="ml-4">{location.postcode}</div>
                </div>
                <Button 
                  size="sm" 
                  className="w-full"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleLocationAction(location);
                  }}
                >
                  {type === 'call' ? (
                    <>
                      <Phone className="w-3 h-3" />
                      {location.phonetext}
                    </>
                  ) : (
                    <>
                      <Calendar className="w-3 h-3" />
                      Plan een afspraak
                    </>
                  )}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};